import {
    api, C, sampleFields, sampleInventory, sampleTreatments,
    FRUITETI_CROPS, OPEN_FIELD_CROP_GROUPS, WMO_CODES,
    PERMANENT_CROP_KEYWORDS, OFFLINE_QUEUE_KEY
} from './context.js';
import { initLoginHandlers, checkAuthSession, applyAziendaBranding, showLoginScreen, enterDemoMode } from './auth.js';
import { initCropSelectOptions, initFieldSummaryHandlers, ensureMapReady } from './map.js';
import {
    initRotateHandlers, initTreatmentForm, initInventory, initScanner,
    initExport, initSettingsTab, setCarenzeFilterMode
} from './activities.js';
import { initTabs, switchTab } from './nav.js';
import { initWeather } from './weather.js';

// Register Service Worker for PWA
if ('serviceWorker' in navigator && location.hostname !== 'localhost') {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('sw.js')
            .then(reg => console.log('Service Worker registered successfully!', reg))
            .catch(err => console.error('Service Worker registration failed:', err));
    });
}


export function initThemeManager() {
    const savedTheme = localStorage.getItem('agrilog-theme') || 'agritech-theme';
    document.body.className = savedTheme;
    
    const selector = document.getElementById('theme-selector');
    if (selector) {
        selector.value = savedTheme;
        selector.addEventListener('change', (e) => {
            const newTheme = e.target.value;
            document.body.className = newTheme;
            localStorage.setItem('agrilog-theme', newTheme);
        });
    }
}
export function initAppUrlParams() {
    const params = new URLSearchParams(window.location.search);
    const slug = params.get('azienda');
    if (slug) {
        localStorage.setItem('active_company_slug', slug);
        api.getPublicCompany(slug).catch(() => {
            console.log('[AgriLog] Azienda non trovata (eliminata), pulizia memoria locale...');
            localStorage.removeItem('active_company_slug');
        });
    }
    if (params.get('success') === 'true') {
        setTimeout(() => {
            alert('🎉 Registrazione ed Abbonamento completati con successo! Inserisci la tua email per accedere ad AgriLog.');
            showLoginScreen();
        }, 300);
    }
}
export function showVisitCount(count) {
    const val = document.getElementById('visit-counter-val-sidebar');
    const wrap = document.getElementById('visit-counter-sidebar');
    if (val) val.textContent = count;
    if (wrap) wrap.classList.remove('hidden');
}

export async function incrementAndShowVisits() {
    try {
        const res = await fetch('/api/public/visits/increment', { method: 'POST' });
        const data = await res.json();
        if (data && data.visits !== undefined) {
            showVisitCount(data.visits);
            return;
        }
    } catch (err) {
        // fallback sotto
    }
    try {
        const res = await fetch('/api/public/visits');
        const data = await res.json();
        if (data && data.visits !== undefined) showVisitCount(data.visits);
    } catch (err) {
        // Silenzioso: contatore non critico
    }
}

export async function startApp() {
    if (C.appHasStarted) return;
    C.appHasStarted = true;
    console.log('[AgriLog] Avvio inizializzazione unificata app...');

    const loadWeather = (lat, lon) => {
        initWeather(lat, lon).catch((e) => console.warn('[AgriLog] Meteo init error:', e));
    };

    const fallbackWeather = () => {
        if (C.state.fields && C.state.fields.length > 0 && C.state.fields[0].coords && C.state.fields[0].coords.length > 0) {
            const firstCoord = C.state.fields[0].coords[0];
            loadWeather(firstCoord[0], firstCoord[1]);
        } else {
            loadWeather(41.958, 13.535);
        }
    };

    try {
        incrementAndShowVisits();
        await applyAziendaBranding();
        initThemeManager();
        try { initLoginHandlers(); } catch (e) { console.error('[AgriLog] initLoginHandlers ERR:', e); }
        try { initCropSelectOptions(); } catch (e) { console.error('[AgriLog] initCropSelectOptions ERR:', e); }
        try { initFieldSummaryHandlers(); } catch (e) { console.error('[AgriLog] initFieldSummaryHandlers ERR:', e); }
        try { initRotateHandlers(); } catch (e) { console.error('[AgriLog] initRotateHandlers ERR:', e); }
        try { initTabs(); } catch (e) { console.error('[AgriLog] initTabs ERR:', e); }
        // Mappa: init lazy al primo accesso al tab (evita tile neri se container nascosto)
        try { initTreatmentForm(); } catch (e) { console.error('[AgriLog] initTreatmentForm ERR:', e); }
        try { initInventory(); } catch (e) { console.error('[AgriLog] initInventory ERR:', e); }
        try { initScanner(); } catch (e) { console.error('[AgriLog] initScanner ERR:', e); }
        try { initExport(); } catch (e) { console.error('[AgriLog] initExport ERR:', e); }
        try { initSettingsTab(); } catch (e) { console.error('[AgriLog] initSettingsTab ERR:', e); }
        initAppUrlParams();

        console.log('[AgriLog] Verifico sessione utente...');
        try {
            await checkAuthSession();
        } catch (e) {
            console.error('[AgriLog] checkAuthSession ERR:', e);
            try { enterDemoMode(); } catch (e2) { console.error('[AgriLog] enterDemoMode ERR:', e2); }
        }
    } catch (e) {
        console.error('[AgriLog] startApp ERR:', e);
        try { enterDemoMode(); } catch (e2) { console.error('[AgriLog] enterDemoMode ERR:', e2); }
    } finally {
        fallbackWeather();
        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition(
                (pos) => loadWeather(pos.coords.latitude, pos.coords.longitude),
                () => { /* fallback già caricato */ },
                { timeout: 5000, enableHighAccuracy: false }
            );
        }
    }
}

window.switchTab = switchTab;
window.setCarenzeFilterMode = setCarenzeFilterMode;

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startApp);
} else {
    startApp();
}
